import React from 'react';
import dice1 from '../images/dice-1.svg';
import dice2 from '../images/dice-2.svg';
import dice3 from '../images/dice-3.svg';
import dice4 from '../images/dice-4.svg';
import dice5 from '../images/dice-5.svg';
import dice6 from '../images/dice-6.svg';

interface DiceProps {
  value: number;
  rolling: boolean;
}

const Dice = ({ value, rolling }: DiceProps): React.ReactElement => {
  const diceImages: { [key: number]: string } = {
    1: dice1,
    2: dice2,
    3: dice3,
    4: dice4,
    5: dice5,
    6: dice6,
  };

  return (
    <div className={`w-24 h-24 bg-white rounded-lg shadow-md flex items-center justify-center overflow-hidden ${rolling ? 'animate-roll' : ''}`}>
      <img src={diceImages[value]} alt={`Dice ${value}`} className="w-full h-full object-contain" />
    </div>
  );
};

export default Dice;